import {gql} from "@irati/utils/gql"
import paymentDetails from "./paymentDetails"

const fragment = gql`
  fragment fullPayment on Payment {
    uuid
    revisionId
    orderId
    amount
    currency
    provider
    status
    details {
      ...paymentDetails
    }
  }
  ${paymentDetails}
`

export const toString = fragment.loc.source.body

export default fragment
